import DonorSections from 'features/donor'
import React from 'react'

const DonorDashboard = () => {
  return (
    <DonorSections />
  )
}

export default DonorDashboard